var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer footer-main"},[_c('div',{staticClass:"footer-logo"},[_c('a',{attrs:{"href":_vm.footerLogoLink}},[_c('img',{staticClass:"footer-logo-procon",attrs:{"src":require("@/assets/proconlogo-h21.svg"),"alt":"Footer Logo"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }